import React, {useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import classNames from 'classnames';
import PopupSelectYear from '../popup-select-year/PopupSelectYear';
import * as actions from '../../_redux/completeDetailsActions';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {generateExcelFile} from '../../../_common/utils/excel';
import {formatPhoneNumberForExcel} from '../../../../../utils';
import ButtonExportToExcel from '../../../_common/components/ButtonExportToExcel';
import {getHeadersCompleteDetails} from '../../../_common/constants/exportedFilesHeaders';
import {completeDetailsHeader} from '../../../_common/constants/exportedFilesMainHeaders';
import {getForm101Year} from '../utils';
import FiltersBar from '../../../_common/components/FiltersBar';
import styles from './styles.module.scss';

export function CompleteDetailsFilter() {
  const dispatch = useDispatch();
  const [popupIsOpen, setPopupIsOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const {currentState} = useSelector(
    (state) => ({currentState: state['completeDetails']}),
    shallowEqual
  );
  const tableRows = currentState.entities ? currentState.entities : [];

  const onChange = async (e) => {
    let file = e.target.files[0];
    await setFile(file);
    await setPopupIsOpen(true);
  };

  const handleFileSubmit = async (year) => {
    if (file) {
      await uploadFileFunc(file, year);
    }
  };

  const uploadFileFunc = async (file, year) => {
    try {
      await dispatch(actions.uploadFileAction(file, year));
    } catch (error) {
      console.error(`Error: + ${error}`);
    }
  };

  const exportCompleteDetailsFileFunc = () => {
    setLoading(true);
    try {
      const data = prepareDataForExcel(tableRows);
      generateExcelFile(data, 'Complete details.xlsx', completeDetailsHeader);
    } catch (error) {
      console.error(`Error: + ${error}`);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const prepareDataForExcel = data => {
    const year = getForm101Year(data);
    const headers = getHeadersCompleteDetails();
    return data.map((item) => {

      return {
        [headers.employeeID]: item.employeeID,
        [headers.idNumber]: item.idNumber,
        [headers.fullName]: item.fullName,
        [headers.bankCode]: item.bankCode,
        [headers.branchNumber]: item.branchNumber,
        [headers.accountNumber]: item.accountNumber,
        [headers.amount]: item.amount,
        [headers.agentID]: item.agentID,
        [headers.phone]: formatPhoneNumberForExcel(`${item.phone}`),
        [headers.email]: item.email,
        [headers.year]: (year) ? getForm101ExistLabel(item.form101FilesForSpecifiedYearExist) : '',
        [headers.comments]: item.comment,
      };
    });
  };

  const getForm101ExistLabel = filesExists => {
    if (filesExists === null) {
      return '';
    } else {
      return filesExists ? 'כן' : 'לא';
    }
  };

  return (
    <FiltersBar
      buttons={
        <div className="d-flex align-items-center justify-content-center">
          <label className={classNames(styles.buttonUpload, 'btn btn-sm p-0 mb-0')}>
            <img
              src={toAbsoluteUrl('/media/svg/Uploaded-file_white.svg')}
              alt="upload-file"
              height={24}
            />
            <input
              type="file"
              className="d-none"
              onChange={onChange}
              onClick={(e) => {
                e.target.value = null;
              }}
            />
          </label>
          <ButtonExportToExcel
            loading={loading}
            exportFunc={exportCompleteDetailsFileFunc}
          />
          <PopupSelectYear
            isOpen={popupIsOpen}
            onSubmit={handleFileSubmit}
            close={() => setPopupIsOpen(false)}
          />
        </div>
      }
    />
  );
}
